import React from "react"
import Popup from "./Popup"
import '../App.css';
import { useState } from "react";
import Button from "./Button"
import EditText from "./EditText"
import API_URLS from "../Urls"; 
const NewClient =({onClose, onAccept})=>{
    const [clientData,setClientData] = useState({nombre:"",apellidos:"",correo:"",telefono:"",estado:"",ciudad:"",calle:"",numero:"",no_apt:"",codigo_postal:"",razon_social:"",rfc:"",codigo_postal_fiscal:"",regimen_fiscal:""})
    const [name,setName] = useState('')
    const [surnames,setSurnames] = useState('')
    const [email,setEmail] = useState('')
    const [phone,setPhone] = useState('')
    
    const processClientInfo = () =>{
        if(clientData.nombre=="" || clientData.telefono ==""){
            alert("Por favor llene todos los campos requeridos")
            return
        }
        postData(clientData,()=>{onAccept()})
    }
    const postData = (dataToSend,onSuccesful) =>{
        fetch(API_URLS.CLIENTS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend) // Convert the object to JSON
        })
        .then(response => {
            console.log(dataToSend);
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(data => {
            console.log(data)
            if (typeof onSuccesful === 'function') 
                onSuccesful(data);
        })
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }
    return (
        <Popup title="Agregar Cliente" onClose={onClose}>
            <div className="new-client-container">
                <div className="invisible-horizontal-container">
                    <div className="form-field">
                        <label>Nombre:<span className="required">*</span></label>
                        <EditText onChange={data=>setClientData(prev=>({...prev,nombre:data}))} text={"Nombre.."}></EditText>
                    </div>
                    <div className="form-field">
                        <label>Apellidos:</label>
                        <EditText onChange={data=>setClientData(prev=>({...prev,apellidos:data}))}></EditText>
                    </div>                       
                </div>
                <div className="invisible-horizontal-container">
                    <div className="form-field">
                        <label>Correo:<span className="required">*</span></label>
                        <EditText onChange={data=>setClientData(prev=>({...prev,correo:data}))}text={"Correo.."}></EditText>
                    </div>
                    <div className="form-field">
                        <label>Teléfono:<span className="required">*</span></label>
                        <EditText onChange={data=>setClientData(prev=>({...prev,telefono:data}))}text={"Telefono"}></EditText>
                    </div>
                </div>
                

                <div className="header1">Direccion</div>
                    <div className="invisible-horizontal-container">
                        <div className="form-field">
                            <label>Estado:<span className="required">*</span></label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,estado:data}))} text={"Estado.."}></EditText>
                        </div>
                        <div className="form-field">
                            <label>Ciudad:<span className="required">*</span></label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,ciudad:data}))} text={"Ciudad"}></EditText>
                        </div>
                    </div>
                    <div className="invisible-horizontal-container">
                        <div className="form-field">
                            <label>Calle:</label> 
                            <EditText onChange={data=>setClientData(prev=>({...prev,calle:data}))} text={"Calle.."}></EditText>
                        </div>
                        <div className="form-field">
                            <label>Número:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,numero:data}))} text={"Numero.."}></EditText>
                        </div>
                        <div className="form-field">
                            <label>no_apt:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,no_apt:data}))} text={"No. apt"}></EditText>
                        </div>
                        <div className="form-field">
                            <label>Codigo Postal:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,codigo_postal:data}))} text={"Codigo postal"}></EditText>
                        </div>
                    </div>
                    <div className="header1">Informacion fiscal</div>
                    <div className="invisible-horizontal-container">
                        <div className="form-field">
                            <label>Razon social:</label> 
                            <EditText onChange={data=>setClientData(prev=>({...prev,razon_social:data}))} text={"Razon social.."}></EditText>
                        </div>
                        <div className="form-field">
                            <label>RFC:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,rfc:data}))} text={"RFC.."}></EditText>
                        </div>
                        <div className="form-field">
                            <label>Codigo postal fiscal:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,codigo_postal_fiscal:data}))} text={"Codigo postal fiscal"}></EditText>
                        </div>
                        <div className="form-field">
                            <label>Regimen fiscal:</label>
                            <EditText onChange={data=>setClientData(prev=>({...prev,regimen_fiscal:data}))} text={"Regimen fiscal"}></EditText>
                        </div>
                    </div>
                <div className="justify-right"><Button onClick={()=>{processClientInfo()}} color={"#61BAA5"} text={"Agregar"}></Button></div>
            </div>
        </Popup>
    )
}
export default NewClient;